import { ActionType } from '../../constants/ActionTypes';

import config from '../../constants/Configs';
import Utils from '../../services/Utils';
import { Constants } from '../../constants/Constants';
import { RestPath } from '../../constants/SitePaths';
import NotificationService from '../../components/base/notifications/NotificationService'
import axios from 'axios';
import { ErrorHelper } from '../../services/helpers/error/ErrorHelper';
import { LanguageService } from '../../services/LanguageService';
import SportHelper from '../../services/helpers/sport/SportHelper';
import { SportDispatchingEventType } from '../../services/helpers/sport/enums/SportEventType';

// Get Bonusues 
export const getBonusesBegin = (data) => ({
  type: ActionType.GET_BONUSES_BEGIN,
  payload: data
});

export const getBonusesError = (data) => ({
  type: ActionType.GET_BONUSES_ERROR,
  payload: data
});

export const getBonusesSuccess = (data) => ({
  type: ActionType.GET_BONUSES_SUCCESS,
  payload: data
});


export function getBonuses(params, history = false) {
  return dispatch => {

    dispatch(getBonusesBegin());

    let url = history ? RestPath.GET_CLIENT_BONUS_HISTORY : RestPath.GET_BONUSES;
    return axios({
      method: Constants.GET,
      url: `${config.BASE_URL}${url}${Utils.objectToQueryParams(params)}`
    }).then((response) => {
      dispatch(getBonusesSuccess(response.data));
      return response.data
    })
      .catch((error) => {
        if (error.response) {
          dispatch(getBonusesError(error.response.data));
        } else {
          dispatch(getBonusesError(error));
        }
      });

  };
}

// Get Prizes
export const getPrizesBegin = (data) => ({
  type: ActionType.GET_PRIZES_BEGIN,
  payload: data
});

export const getPrizesError = (data) => ({
  type: ActionType.GET_PRIZES_ERROR,
  payload: data
});

export const getPrizesSuccess = (data) => ({
  type: ActionType.GET_PRIZES_SUCCESS,
  payload: data
});

export function getPrizes(params) {
  return dispatch => {
    dispatch(getPrizesBegin());
    return axios({
      method: Constants.GET,
      url: config.BASE_URL + RestPath.GET_PRIZES_HISTORY + Utils.objectToQueryParams(params),
    }).then((response) => {
      dispatch(getPrizesSuccess(response.data));
      return response.data
    })
      .catch((error) => {
        if (error.response) {
          dispatch(getPrizesError(error.response.data));
        } else {
          dispatch(getPrizesError(error));
        }
      });

  };
}

// Get Bonus Games
export const getBonusGamesBegin = (data) => ({
  type: ActionType.GET_BONUS_GAMES_BEGIN,
  payload: data
});

export const getBonusGamesError = (data) => ({
  type: ActionType.GET_BONUS_GAMES_ERROR,
  payload: data
});

export const getBonusGamesSuccess = (id, data) => ({
  type: ActionType.GET_BONUS_GAMES_SUCCESS,
  payload: { bonusId: id, games: data }
});


export function getBonusGames(id, clientBonusId) {
  return dispatch => {
    dispatch(getBonusGamesBegin());
    return axios({
      method: Constants.GET,
      url: `${config.BASE_URL}${RestPath.GET_BONUS_GAMES}?id=${clientBonusId}`
    }).then((response) => {
      dispatch(getBonusGamesSuccess(id, response.data));
    })
      .catch((error) => {
        if (error.response) {
          dispatch(getBonusGamesError(error.response.data));
        } else {
          dispatch(getBonusGamesError(error));
        }
      });
  };
}

// Change Bonus Status
export const activateBonusPromoBegin = () => ({
  type: ActionType.ACTIVATE_PROMO_CODE_BEGIN,
});

export const activateBonusPromoError = (data) => ({
  type: ActionType.ACTIVATE_PROMO_CODE_ERROR,
  payload: data
});

export const activateBonusPromoSuccess = (data) => ({
  type: ActionType.ACTIVATE_PROMO_CODE_SUCCESS,
  payload: data
});


export const closePromoCodeSuccessModal = () => ({
  type: ActionType.CLOSE_PROMO_CODE_SUCCESS_MODAL,
});


// Get Bonus Campaign
export const getBonusCamaignsBegin = () => ({
  type: ActionType.GET_BONUS_CAMPAIGNS_BEGIN,
});
export const getBonusCamaignsNoResetBegin = () => ({
  type: ActionType.GET_BONUS_CAMPAIGNS_LOAD_MORE_BEGIN,
});


export const getBonusCamaignsError = (data) => ({
  type: ActionType.GET_BONUS_CAMPAIGNS_ERROR,
  payload: data
});

export const getBonusCamaignsSuccess = (data) => ({
  type: ActionType.GET_BONUS_CAMPAIGNS_SUCCESS,
  payload: data
});

export const checkBalanceSwitcher = (data) => ({
  type: ActionType.CHECK_BALANCE_SWITCHER,
  payload: data
})

// Get Bonus Details
export const getBonusDetailsBegin = () => ({
  type: ActionType.GET_BONUS_DETAILS_BEGIN,
});

export const getBonusDetailsError = (data) => ({
  type: ActionType.GET_BONUS_DETAILS_ERROR,
  payload: data
});

export const getBonusDetailsSuccess = (data) => ({
  type: ActionType.GET_BONUS_DETAILS_SUCCESS,
  payload: data
});

// Get Bonus Games
export const getBonusProductsBegin = () => ({
  type: ActionType.GET_BONUS_PRODUCTS_BEGIN,
});
export const getBonusProductsLoadMoreBegin = () => ({
  type: ActionType.GET_BONUS_PRODUCTS_LOAD_MORE_BEGIN,
});


export const getBonusProductsError = (data) => ({
  type: ActionType.GET_BONUS_PRODUCTS_ERROR,
  payload: data
});

export const getBonusProductsSuccess = (data) => ({
  type: ActionType.GET_BONUS_PRODUCTS_SUCCESS,
  payload: data
});

// Get Bonus Games
export const activateBonusCampaignBegin = () => ({
  type: ActionType.ACTIVATE_BONUS_CAMPAIGN_BEGIN,
});

export const activateBonusCampaignError = (data) => ({
  type: ActionType.ACTIVATE_BONUS_CAMPAIGN_ERROR,
  payload: data
});

export const activateBonusCampaignSuccess = (data) => ({
  type: ActionType.ACTIVATE_BONUS_CAMPAIGN_SUCCESS,
  payload: data
});

// Get Bonus Games
export const cancelBonusCampaignBegin = () => ({
  type: ActionType.CANCEL_BONUS_CAMPAIGN_BEGIN,
});

export const cancelBonusCampaignError = (data) => ({
  type: ActionType.CANCEL_BONUS_CAMPAIGN_ERROR,
  payload: data
});

export const cancelBonusCampaignSuccess = (data) => ({
  type: ActionType.CANCEL_BONUS_CAMPAIGN_SUCCESS,
  payload: data
});

export const resumeBonusCampaignBegin = () => ({
  type: ActionType.RESUME_BONUS_CAMPAIGN_BEGIN,
});

export const resumeBonusCampaignSuccess = () => ({
  type: ActionType.RESUME_BONUS_CAMPAIGN_SUCCESS,
});

export const resumeBonusCampaignError = () => ({
  type: ActionType.RESUME_BONUS_CAMPAIGN_ERROR,
});

// Get Sport Types

export const getSportTypesBegin = () => ({
  type: ActionType.GET_SPORT_TYPES_BEGIN,
});

export const getSportTypesError = (data) => ({
  type: ActionType.GET_SPORT_TYPES_ERROR,
  payload: data
});

export const getSportTypesSuccess = (data) => ({
  type: ActionType.GET_SPORT_TYPES_SUCCESS,
  payload: data
});

// Get Sport Tournaments

export const getBonusTournamentsBegin = () => ({
  type: ActionType.GET_BONUS_TOURNAMENTS_BEGIN,
});

export const getBonusTournamentsError = (data) => ({
  type: ActionType.GET_BONUS_TOURNAMENTS_ERROR,
  payload: data
});

export const getBonusTournamentsSuccess = (data) => ({
  type: ActionType.GET_BONUS_TOURNAMENTS_SUCCESS,
  payload: data
});

// Get Sport Events

export const getBonusEventsBegin = () => ({
  type: ActionType.GET_BONUS_EVENTS_BEGIN,
});

export const getBonusEventsError = (data) => ({
  type: ActionType.GET_BONUS_EVENTS_ERROR,
  payload: data
});

export const getBonusEventsSuccess = (data) => ({
  type: ActionType.GET_BONUS_EVENTS_SUCCESS,
  payload: data
});

// Get Active Bonus Settings Count

export const getActiveBonusSettingsCountBegin = () => ({
  type: ActionType.GET_CLIENT_ACTIVE_BONUS_SETTINGS_COUNT_BEGIN,
});

export const getActiveBonusSettingsCountError = (data) => ({
  type: ActionType.GET_CLIENT_ACTIVE_BONUS_SETTINGS_COUNT_ERROR,
  payload: data
});

export const getActiveBonusSettingsCountSuccess = (data) => ({
  type: ActionType.GET_CLIENT_ACTIVE_BONUS_SETTINGS_COUNT_SUCCESS,
  payload: data
});

export const setNewBonusCount = (data) => ({
  type: ActionType.SET_CLIENT_NEW_BONUS_SETTINGS_COUNT_SUCCESS,
  payload: data
});


export function activateBonusPromoCode(data) {
  return dispatch => {
    dispatch(activateBonusPromoBegin());

    return axios({
      method: Constants.POST,
      url: `${config.BASE_URL}${RestPath.ACTIVATE_PROMO_CODE}`,
      data
    }).then((response) => {
      dispatch(activateBonusPromoSuccess(response && response.data));
    })
      .catch((error) => {
        dispatch(activateBonusPromoError(error.response.data));
        NotificationService.error({ message: ErrorHelper.getMessage(error) });
      });
  };
}

export function activateBonusV2PromoCode(data) {
  return dispatch => {
    dispatch(activateBonusPromoBegin());
    return axios({
      method: Constants.POST,
      url: `${config.BASE_URL}${RestPath.ACTIVATE_PROMO_CODE_V2}`,
      data
    }).then((response) => {
      dispatch(activateBonusPromoSuccess(response && response.data));
    })
      .catch((error) => {
        dispatch(activateBonusPromoError(error.response.data));
        NotificationService.error({ message: ErrorHelper.getMessage(error) });
      });
  };
}

export function getBonusCamaigns(type, page, bonusType) {
  return dispatch => {
    page === 1 ? dispatch(getBonusCamaignsBegin()) : dispatch(getBonusCamaignsNoResetBegin());

    let params = {
      ['productType']: type,
      ['page']: page,
      ['top']: 100,
    }

    return axios({
      method: Constants.GET,
      url: `${config.BASE_URL}${RestPath.GET_BONUS_CAMPAIGNS}`,
      params: params
    }).then((response) => {
      return response.data
    })
      .catch((error) => {
        dispatch(getBonusCamaignsError(error.response.data));
      });
  };
}

export function getBonusDetails(id) {
  return dispatch => {
    dispatch(getBonusDetailsBegin());
    return axios({
      method: Constants.GET,
      url: `${config.BASE_URL}${RestPath.GET_BONUS_DETAILS}`,
      params: { clientBonusCampaignId: id }
    }).then((response) => {
      dispatch(getBonusDetailsSuccess(response.data));
    })
      .catch((error) => {
        dispatch(getBonusDetailsError(error.response.data));
      });
  };
}
export function getBonusProducts(id, bonusCampaignId, pageId, takeCount, productName) {
  return dispatch => {
    pageId === 1 ? dispatch(getBonusProductsBegin()) : dispatch(getBonusProductsLoadMoreBegin());
    return axios({
      method: Constants.GET,
      url: `${config.BASE_URL}${RestPath.GET_BONUS_PRODUCTS}`,
      params: { clientBonusCampaignId: id, bonusCampaignId, pageId, takeCount, productName }
    }).then((response) => {
      dispatch(getBonusProductsSuccess({ data: response.data, isSearch: productName !== null }));
    })
      .catch((error) => {
        dispatch(getBonusProductsError(error.response.data));
      });
  };
}


export function cancelBonusCampaign(id) {
  return dispatch => {
    // dispatch(cancelBonusCampaignBegin());
    const params = { clientBonusCampaignId: id }
    return axios({
      method: Constants.POST,
      url: `${config.BASE_URL}${RestPath.CANCEL_BONUS_CAMPAIGN}`,
      params
    }).then((response) => {
      response && response.data.message && NotificationService.success({ message: response && response.data.message })
      // dispatch(cancelBonusCampaignSuccess(response.data));
      //Shame on us for this ))
      SportHelper.dispatchEvent(SportDispatchingEventType.UpdateFreeBet);
      return true;
    }).catch((error) => {
      console.log(error);
      NotificationService.error({ message: error && error.message })
      // dispatch(cancelBonusCampaignError(error.response.data));
    });
  }
}

export function activateBonusCampaign(id) {
  return dispatch => {
    dispatch(activateBonusCampaignBegin());
    const params = { clientBonusCampaignId: id }
    return axios({
      method: Constants.POST,
      url: `${config.BASE_URL}${RestPath.ACTIVATE_BONUS_CAMPAIGN}`,
      params
    }).then((response) => {
      if (response?.data) {
        NotificationService.success({
          message: response.message || LanguageService.getTranslation('success', 'account'),
        });
        dispatch(activateBonusCampaignSuccess(response.data));
        //Shame on us for this ))
        SportHelper.dispatchEvent(SportDispatchingEventType.UpdateFreeBet);
      }
      return true;
    }).catch((error) => {
      if (error) {
        NotificationService.error({ message: ErrorHelper.getMessage(error) })
        dispatch(activateBonusCampaignError(error.response.data));
      }
    });
  }
}

export function pauseBonusCampaign(id) {
  return dispatch => {
    const params = { clientBonusCampaignId: id }
    return axios({
      method: Constants.POST,
      url: `${config.BASE_URL}${RestPath.PAUSE_CLIENT_BONUS_CAMPAIGN}`,
      params
    }).then((response) => {
      return true;
    }).catch((error) => {
      NotificationService.error({ message: error && error.message })
    });
  }
}

export function resumeBonusCampaign(id) {
  return dispatch => {
    dispatch(resumeBonusCampaignBegin());
    const params = { clientBonusCampaignId: id }
    return axios({
      method: Constants.POST,
      url: `${config.BASE_URL}${RestPath.RESUME_CLIENT_BONUS_CAMPAIGN}`,
      params
    }).then((response) => {
      dispatch(resumeBonusCampaignSuccess());
      return true;
    }).catch((error) => {
      dispatch(resumeBonusCampaignError());
      NotificationService.error({ message: error && error.message })
    });
  }
}

export function getAttachedBonusInfo(id) {
  return dispatch => {
    return axios({
      method: Constants.GET,
      url: `${config.BASE_URL}${RestPath.GET_ATTACHED_BONUS_INFO}`,
      params: { bonusId: id }
    }).then((response) => {
      return response.data;
    }).catch((error) => {
      return error;
    });
  };
}


export const getClientBonusWalletStateBegin = (data) => ({
  type: ActionType.GET_BONUS_WALLET_BEGIN,
  payload: data
});

export const getClientBonusWalletStateError = (data) => ({
  type: ActionType.GET_BONUS_WALLET_ERROR,
  payload: data
});

export const getClientBonusWalletStateSuccess = (data) => ({
  type: ActionType.GET_BONUS_WALLET_SUCCESS,
  payload: data
});
export const changeClientBonusWalletState = (data) => ({
  type: ActionType.CHANGE_CLIENT_BONUS_WALLET_STATE,
  payload: data
});

export function getClientBonusWalletState() {

  return dispatch => {
    dispatch(getClientBonusWalletStateBegin());
    return axios({
      method: Constants.GET,
      url: `${config.BASE_URL}${RestPath.GET_CLIENT_BONUS_WALLET_STATE}`

    }).then((response) => {
      dispatch(getClientBonusWalletStateSuccess(response.data));
      return response.data?.data?.IsBonusWalletActive;
    })
      .catch((error) => {
        if (error.response) {
          dispatch(getClientBonusWalletStateError(error.response.data));
        } else {
          dispatch(getClientBonusWalletStateError(error));
        }
      });
  }
}

export function switchClientWalletState(type) {
  return dispatch => {
    const params = { turnOnBonusWalletState: type }
    return axios({
      method: Constants.GET,
      url: `${config.BASE_URL}${RestPath.CHANGE_CLIENT_BONUS_WALLET_STATE}`,
      params: params
    }).then((response) => {
      dispatch(changeClientBonusWalletState(type));
      return true;
    }).catch((error) => {
      NotificationService.error({ message: LanguageService.getTranslation('genericErrorMsg') })
    });
  }
}

export function getSportTypes(id) {
  return dispatch => {
    dispatch(getSportTypesBegin());
    return axios({
      method: Constants.GET,
      url: `${config.BASE_URL}${RestPath.GET_BONUS_SPORTS}`,
      params: { clientBonusCampaignId: id }
    }).then((response) => {
      dispatch(getSportTypesSuccess(response.data));
      return response.data
    })
      .catch((error) => {
        dispatch(getSportTypesError(error.response.data));
      });
  };
}

export function getBonusTournaments(bonusId, sportId) {
  return dispatch => {
    dispatch(getBonusTournamentsBegin());
    return axios({
      method: Constants.GET,
      url: `${config.BASE_URL}${RestPath.GET_BONUS_TOURNAMENTS}`,
      params: { clientBonusId: bonusId, sportId }
    }).then((response) => {
      dispatch(getBonusTournamentsSuccess(response.data));
      return response.data
    })
      .catch((error) => {
        dispatch(getBonusTournamentsError(error.response.data));
      });
  };
}

export function getBonusEvents(bonusId, tournamentId) {
  return dispatch => {
    dispatch(getBonusEventsBegin());
    return axios({
      method: Constants.GET,
      url: `${config.BASE_URL}${RestPath.GET_BONUS_EVENTS}`,
      params: { clientBonusId: bonusId, tournamentId }
    }).then((response) => {
      dispatch(getBonusEventsSuccess(response.data));
      return response.data
    })
      .catch((error) => {
        dispatch(getBonusEventsError(error.response.data));
      });
  };
}

export function getLinkedBonuses(bonusId, iterationKey) {
  return dispatch => {
    return axios({
      method: Constants.GET,
      url: `${config.BASE_URL}${RestPath.GET_CLIENT_LINKED_BONUSES}`,
      params: { clientBonusId: bonusId, iterationKey }
    }).then((response) => {
      return response.data
    }).catch((error) => {
      NotificationService.error({ message: LanguageService.getTranslation('genericErrorMsg') })
    });
  };
}

export function getActiveBonusSettingsCount(data) {
  return dispatch => {
    dispatch(getActiveBonusSettingsCountBegin());
    return axios({
      method: Constants.GET,
      url: `${config.BASE_URL}${RestPath.GET_CLIENT_ACTIVE_BONUS_SETTINGS_COUNT}`,
      data
    }).then((response) => {
      dispatch(getActiveBonusSettingsCountSuccess(response.data));
      return response.data
    })
      .catch((error) => {
        dispatch(getActiveBonusSettingsCountError(error.response.data));
      });
  };
}
/** Dummy  */
function delay(t, val) {
  return new Promise(resolve => setTimeout(resolve, t, val));
}

export function getBonusRequestItems() {
  return dispatch => {
    return axios({
      method: Constants.GET,
      url: `${config.BASE_URL}${RestPath.GET_BONUS_REQUEST_ITEMS}`
    }).then((response) => {
      return response.data
    }).catch((error) => { });
  };
}